<template>
  <a-modal v-model:open="visible" :footer="null" :closable="false" :width="$store.getters.get_notMobileView ? '77%':'86%'">
    <div>
      <ul
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        "
      >
        <li @click="showModal" style="cursor: pointer">
          &lt;&lt; {{ $t('common.back') }}
        </li>
        <li>
          <a-button
            @click="chooseShopConfirm"
            type="primary"
            style="background: #11254a; border-color: #11254a"
            >{{ $t('common.confirm') }}</a-button
          >
        </li>
      </ul>
      <!-- style="display: flex; justify-content: space-between" -->
      <ul class="shopmSearchBox">
        <li style="flex: 1; background: #dddee2; height: 400px; padding: 8px">
          <div class="searchInutBox">
            <!-- style="border: 0; flex: 0 0 120px; margin-right: 10px" -->
            <a-input
              v-model:value="ShopInput"
              :placeholder="$t('component.ShopM.searchShop')"
            >
            </a-input>
            <!-- style="
                flex: 0 0 20%;
                height: 30px;
                background: #395489;
                border-color: #395489;
                margin-right: 10px;
              " -->
            <a-button @click="ShopSearchAndChoose" type="primary">{{
              $t('common.searchAndChoose')
            }}</a-button>
            <!-- style="
                flex: 0 0 20%;
                height: 30px;
                background: #395489;
                border-color: #395489;
              " -->
            <a-button
              @click="selectedShop('all')"
              type="primary"
              :style="{ display: isSingleChoose == '1' ? 'none' : 'block' }"
              >{{ $t('common.chooseAll') }}</a-button
            >
          </div>
          <!-- style="display: flex; height: 90%; margin-top: 8px" -->
          <!-- class="selectedShops" -->
          <div :class="[isSingleChoose == '1'? 'selectedShopsSignleBtn':'selectedShops']">
            <div class="stationList">
              <ul
                style="
                  display: flex;
                  padding: 10px;
                  flex-wrap: wrap;
                  color: #395489;
                "
              >
                <li
                  @click="selectedShop(s.id)"
                  :class="s.isActive"
                  v-for="s in Shops"
                  :key="s.id"
                >
                  {{ s.name }}
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ShopChoose',
  props: ['isSingleChoose'],
  data() {
    return {
      visible: false,
      ShopList: '',
      Shops: '',
      ShopInput: '',
    };
  },
  methods: {
    showModal() {
      if (this.visible) this.visible = false;
      else this.visible = true;
    },
    selectedShop(id) {
      let isActive = this.Shops[0].isActive;
      this.Shops.forEach((m) => {
        if (id == 'all') {
          if (this.isSingleChoose != '1') {
            if (!isActive) m.isActive = 'selectedShop';
            else m.isActive = '';
          }
        } else {
          if (m.id == id) {
            if (m.isActive) m.isActive = '';
            else m.isActive = 'selectedShop';
          } else {
            if (this.isSingleChoose == '1') m.isActive = '';
          }
        }
      });
    },
    ShopSearchAndChoose() {
      let isChooseShoped = true;
      this.Shops.forEach((m) => {
        if (
          this.ShopInput &&
          m.name.toLowerCase().indexOf(this.ShopInput.toLowerCase()) > -1 &&
          isChooseShoped
        ) {
          isChooseShoped = false;
          m.isActive = 'selectedShop';
        } else if (this.isSingleChoose == '1') m.isActive = '';
      });
    },
    chooseShopConfirm() {
      let s = [];
      this.Shops.forEach((m) => {
        if (m.isActive) {
          s.push(m);
        }
      });

      this.ShopList = s;
      this.visible = false;
      this.$emit('chooseShopConfirm', s);
    },
    resetSites(sites) {
      this.ShopList = [];
      var shops = [];

      var shopCollection = JSON.parse(
        this.$store.getters.get_shop_collection_cache
      ).shops;
      shopCollection.forEach((shop) => {
        shop.isActive = '';
        if (!shop.shopLocation) {
          shops.push(shop);
        } else if (
          sites.some(
            (s) =>
              s.id == shop.shopLocation.id && s.type == shop.shopLocation.type
          )
        ) {
          shops.push(shop);
        }
      });
      this.Shops = shops;
    }
  }
};
</script>

<style scoped>
.stationList {
  flex: 1;
  background: white;
  border-radius: 0px 4px 4px;
  overflow-y: auto;
}
.stationList li {
  background: #edeef0;
  flex: 0 0 24%;
  height: 35px;
  margin: 5px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  padding: 0px 7px;
}
.selectedShop {
  background: #a6bce3 !important;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #edeef0;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 8px;
  background: #c6cad1;
}

/* 整理内联样式 */
.shopmSearchBox {
  display: flex;
  justify-content: space-between;
}

.searchInutBox {
  display: flex;
}

.selectedShops,.selectedShopsSignleBtn {
  display: flex;
  height: 90%;
  margin-top: 8px;
}

.searchInutBox > input[type='text'] {
  border: 0;
  flex: 0 0 120px;
  margin-right: 10px;
}
.searchInutBox > button {
  flex: 0 0 20%;
  height: 30px;
  background: #395489;
  border-color: #395489;
  margin-right: 10px;
}
@media (max-width: 420px) {
  .selectedShops {
    height: 73%;
  }
  .selectedShopsSignleBtn{
     height: 80%;
  }
  .searchInutBox {
    display: flex;
    flex-direction: column;
    align-items: inherit;
  }
  .searchInutBox > input[type='text'] {
    flex: none;
    margin-bottom: 10px;
  }
  .searchInutBox > button {
    margin-bottom: 5px;
    margin-right: 0px;
  }
  .stationList li {
    flex: 0 0 100%;
    margin: 5px auto;
  }
}
</style>
